import Axios from "axios";
import useAxios from "axios-hooks";
import { useCallback, useEffect, useMemo, useRef } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { paths } from "../routes";

const setAuthorization = jwt => {
    if (!!!jwt) return {};
    return {
        Authorization: `Bearer ${jwt}`
    };
};

export const useApi = (fn, options) => {
    const { t } = useTranslation()
    const manual = useMemo(
        () => options?.manual ?? false,
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [JSON.stringify(options)]
    );
    const optionsAxios = useMemo(
        () => ({ manual: true, useCache: options?.useCache ?? true }),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [JSON.stringify(options)]
    );

    const [state, execute] = useAxios({}, optionsAxios);
    const user = useSelector(state => state.auth.user);
    const history = useHistory();

    const callFn = useRef(fn);
    useEffect(() => {
        callFn.current = fn;
    }, [fn]);

    const request = useCallback(
        (...args) => {
            const config = callFn.current(...args);
            const authorization = setAuthorization(user?.jwt);
            return execute({ ...config, headers: { ...authorization } })
                .catch((error) => {
                    if (Axios.isCancel(error)) {
                        console.log('Request canceled.', error?.message);
                    } else if (error?.response) {
                        const errorMessage = error?.response?.data?.message;
                        toast.error(errorMessage ? errorMessage : t('Problem z zapytaniem'));
                        if (error?.response?.status === 401 || error?.response?.status === 403) {
                            if (user?.jwt) {
                                history.push(paths.logout);
                            }
                        }
                    } else {
                        //Logout when is "Network error"
                        if (user?.jwt) {
                            history.push(paths.logout);
                        }
                        toast.error(t("Błąd sieci"));
                    }
                    throw error;
                });
        },
        [user, execute, history, t]
    );

    useEffect(() => {
        if (!!manual) return;
        request();
    }, [manual, request]);

    return [state, request];
};